/**
 * The page a contract's QR code opens. Public: whoever scanned it has no account here, and the
 * token in the path is the only key. Kept outside /profile so nothing from the student area, which
 * fetches the signed-in student, runs on it.
 */
export default [
  {
    path: "/student/:token",
    name: "PublicPersonalInfo",
    meta: { layout: "public", public: true },
    component: () =>
      import("@/modules/PublicProfile/pages/PPublicPersonalInfo.vue"),
  },
  {
    path: "/student/:token/contacts",
    name: "PublicContacts",
    meta: { layout: "public", public: true },
    props: { publicMode: true },
    component: () => import("@/modules/Profile/pages/PContacts.vue"),
  },
];
